//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VueClazyLoad } from 'vue-clazy-load'
import { marked } from 'marked'
const format = require('string-template');

export default {
  components: {
    VueClazyLoad
  },
  data() {
    return {
      trustpilot_business_unit_id: null,
      trustpilot_template_id: null,
      footer_text: this.$store.state.site_settings.data?.footer_text ?? '',
      footer_copyright: this.$store.state.site_settings.data?.footer_copyright ?? '',
      trustpilot_locale: 'en',
      showFooterText: false,
      current: null,
      version: null
    }
  },
  computed: {
    seoFooter() {
      return _.get(this.$store.state.seo, 'meta.footer')
    },
    showTrustpilotWidget() {
      this.trustpilot_business_unit_id = this.$store.state.site_settings.data?.trustpilot_info?.business_unit_id ?? null
      this.trustpilot_template_id = this.$store.state.site_settings.data?.trustpilot_info?.template_id ?? null
      let _regex = /^([0-9A-Fa-f]{24})+$/
      return this.trustpilot_business_unit_id !== null && this.trustpilot_template_id  !== null
          && this.trustpilot_business_unit_id.match(_regex) != null && this.trustpilot_template_id .match(_regex) !== null;
    }
  },
  watch: {
    $route: function (value) {
      this.showFooterText = false
    },
    seoFooter: function (value) {
      this.showFooterText = value && value.length < 200;
    }
  },
  methods: {
    linkHasAction(link) {
      return !!link.action
    },
    getLinks(links_key) {
      const section = Array.isArray(this.$store.state.globals_new)
        ? this.$store.state.globals_new.find(obj => obj.handle === links_key)
        : null
      const items = Array.isArray(section?.items) ? section.items : []
      return items
        .filter(link => {
          if (!link.active) return false
          if (link?.sidebar_only) return false
          if (!link.url) return false
          return !(link.visibility === 'auth' && !this.user)
        })
        .slice()
        .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
        .map(link => {
          const url =
            !link.is_external
              ? link.url.startsWith('/')
                ? link.url
                : '/' + link.url
              : link.url
          return { ...link, url }
        })
    },
    toggleFooterText() {
      this.showFooterText = !this.showFooterText
    },
    renderMd(string) {
      try {
        let variables = _.get(this.$store.state, 'seo.variables', {})
        string = format(string, variables)
        return marked.parse(string)
      } catch (e) {
        return ''
      }
    },
    openGlobalIframe(path) {
      this.loadGlobalIframe('open_page', { url: path })
    },
    getUrl(url) {
      if (url.match(/^https?:\/\//i)) {
        return url
      } else {
        return this.localePath(_.trim(url))
      }
    }
  }
}
